import styles from './styles.module.scss';
import icWarning from '../../assets/icons/errors/warning.svg';
import icExpired from '../../assets/icons/errors/expired.svg';
import { errorCodes, ErrorInfo } from 'utils/error-codes';
import { useTranslation } from 'react-i18next';

const IconError = (type?: string) => {
  switch (type) {
    case 'expired':
      return icExpired;
    default:
      return icWarning;
  }
};

interface MessageStatusProps {
  errorInfo?: ErrorInfo | null;
}

const MessageStatus = ({ errorInfo }: MessageStatusProps) => {
  const { t } = useTranslation();

  let ic;
  let msgKey = errorCodes.GENERIC_ERROR.keyMessage;
  if (errorInfo) {
    ic = errorInfo.icon;
    msgKey = errorInfo.keyMessage;
  }
  return (
    <div className={styles.message_status}>
      <div>
        <img className={styles.icon_error} src={IconError(ic)} alt="icon-error" />
      </div>
      <div className={styles.message_error}>{t(msgKey)}</div>
    </div>
  );
};

export default MessageStatus;
